import { configureStore } from "@reduxjs/toolkit";
import { rootApi } from "../api/rootApi";
import patientReducer from "../slices/patientSlice";
import authReducer from "../slices/authSlice";
import userReducer from "../slices/userSlice";
import appointmentReducer from "../slices/appointmentsSlice";
import paymentReducer, { setPaymentData } from "../slices/paymentSlice";

// Create and configure the Redux store
const store = configureStore({
  reducer: {
    [rootApi.reducerPath]: rootApi.reducer, // RTK Query reducer
    patient: patientReducer, // Managing patient state
    auth: authReducer, // Managing authentication state
    user: userReducer, // Managing user state
    appointments: appointmentReducer, // ✅ Add appointments reducer
    payment: paymentReducer,  
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(rootApi.middleware), // Add middleware for RTK Query
});

// Initialize patient data from localStorage if available
const initializePatientState = () => {
  const storedPatient = localStorage.getItem("selectedPatient");
  if (storedPatient) {
    const parsedPatient = JSON.parse(storedPatient);
    store.dispatch({
      type: "patient/setSelectedPatient",
      payload: parsedPatient,
    });
    store.dispatch({
      type: "user/setSelectedUser",
      payload: parsedPatient,
    });
  }
};

// Initialize auth data from localStorage if available
const initializeAuthState = () => {
  const authToken = localStorage.getItem("authToken");
  if (authToken) {
    store.dispatch({
      type: "auth/setToken",
      payload: authToken,
    });
  }
};

// Initialize appointment data from localStorage if available
const initializeAppointmentState = () => {
  const storedAppointments = localStorage.getItem("appointments");
  if (storedAppointments) {
    store.dispatch({
      type: "appointments/setAppointments",
      payload: JSON.parse(storedAppointments),
    });
  }
};

const initializePaymentState = () => {
  const stored = localStorage.getItem("paymentData");
  if (stored) {
    try {
      const paymentObj = JSON.parse(stored);
      store.dispatch(setPaymentData(paymentObj));
    } catch {
      localStorage.removeItem("paymentData");
    }
  }
};

// Run the initialization functions
initializePatientState();
initializeAuthState();
initializeAppointmentState();
initializePaymentState();

console.log("Store:", store);

export default store;
